<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="560px"
    custom-class="ca-reason-dialog"
    :close-on-click-modal="true"
  >
    <div slot="title" class="ca-reason-dialog__title">
      <i :class="[iconClass, 'ca-reason-dialog__icon']" />
      <span>{{ meta.title }}</span>
    </div>

    <div class="ca-reason-dialog__order">
      <span class="ca-reason-dialog__order-label">订单号：</span>{{ order.orderCode }}
    </div>

    <!-- 原因区块（含编号的多条原因） -->
    <div class="ca-reason-dialog__box">
      <p class="ca-reason-dialog__prefix">{{ meta.prefix }}</p>
      <ol class="ca-reason-dialog__list">
        <li v-for="(line, i) in reasonLines" :key="i">{{ line }}</li>
      </ol>
    </div>

    <p class="ca-reason-dialog__footer-tip">{{ meta.footer }}</p>

    <div slot="footer">
      <el-button type="danger" @click="close">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
const ICON_CLASS = {
  exclaim: 'el-icon-warning',
  close: 'el-icon-error',
}

// 文案（原型逐字照录）：驳回 / 取消 两版仅 4 处不同（标题 / 图标 / 前缀 / 结尾提示）
const META = {
  reject: {
    title: '驳回原因',
    icon: 'exclaim',
    prefix: '您的资料审核未通过，原因如下：',
    footer: '修改后可重新提交订单。',
    field: 'opinion', // 原因数据源字段
  },
  cancel: {
    title: '取消原因',
    icon: 'close',
    prefix: '您的订单已被取消，原因如下：',
    footer: '如有疑问请联系客服，或重新提交订单。',
    field: 'cancelReason',
  },
}

export default {
  name: 'CaReasonDialog',
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: 'reject' }, // 'reject' | 'cancel'
    order: { type: Object, default: () => ({}) },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
    meta() {
      return META[this.type] || META.reject
    },
    iconClass() {
      return ICON_CLASS[this.meta.icon] || ICON_CLASS.exclaim
    },
    // 原因数据源：reject → opinion；cancel → cancelReason；多条按行拆为有序列表
    reasonLines() {
      const text = this.order[this.meta.field] || ''
      const lines = text.split(/\n+/).filter(Boolean)
      return lines.length ? lines : [text || '--']
    },
  },
  methods: {
    close() {
      this.innerVisible = false
    },
  },
}
</script>
